import React, { useState } from "react";
import { Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.mode === "dark" ? "#2a2a2a" : "#e3e6ea",
    color: theme.mode === "dark" ? "#cfd3d7" : "#5b6470",
    fontWeight: 600,
    fontSize: 14,
  },
}));

const initialsOf = (name = "") => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ContactAvatar = ({ contact, size, className, style, ...rest }) => {
  const classes = useStyles();
  const [errored, setErrored] = useState(false);

  const src = !errored ? contact?.profilePicUrl || contact?.urlPicture : null;

  return (
    <Avatar
      src={src || undefined}
      alt={contact?.name}
      className={[classes.root, className].filter(Boolean).join(" ")}
      style={{
        width: size || 40,
        height: size || 40,
        fontSize: size ? Math.round(size * 0.4) : 14,
        ...(style || {}),
      }}
      imgProps={{
        loading: "lazy",
        onError: () => setErrored(true),
      }}
      {...rest}
    >
      {!src && initialsOf(contact?.name)}
    </Avatar>
  );
};

export default ContactAvatar;
